/** On the public pages and the signed-in shell alike (spec §6.4), on --room with the
 * wordmark (design v2 screen 1). */
import type { MouseEvent } from "react";
import { navigate } from "../app/router";
import { brand } from "../brand";

function go(path: string) {
  return (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate(path);
  };
}

export function Footer() {
  return (
    <footer className="site-footer">
      <span className="site-footer__wordmark">{brand.wordmark}</span>
      <span className="site-footer__links">
        <a href="/terms" onClick={go("/terms")}>
          Terms
        </a>
        <a href="/privacy" onClick={go("/privacy")}>
          Privacy
        </a>
        <a href="/rights" onClick={go("/rights")}>
          Rights holders
        </a>
        <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>
        <span className="site-footer__beta">Beta</span>
      </span>
    </footer>
  );
}
